<template>
  <el-tag
    size="medium"
    :type="
      status === '00'
        ? 'warning'
        : status === '01'
        ? 'success'
        : status === '02' || status === '03'
        ? 'danger'
        : status === '07'
        ? 'info'
        : 'primary'
    "
  >
    {{ $formatter.formatOrderStatus(null, null, status, null) }}
  </el-tag>
</template>
<script>
export default {
  props: {
    status: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
